/**
 * @file   src\components\Payments\StripeElementsWrapper.js
 * @brief  This file is responsible for Stripe elements wrapper
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import PlanReviewModal from "../PlanUpgrade/PlanReviewModal";


const PlanReviewModalWrapper = (props) => {
  return (
      <PlanReviewModal {...props} />
  );
};

export default PlanReviewModalWrapper;
